var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.list.length > 0
    ? _c(
        "div",
        { staticClass: "push-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.list,
                "default-sort": _vm.sortObj,
                "header-cell-style": _vm.headerStyle,
                "max-height": _vm.heightStr,
                "row-key": _vm.getRowKeys,
              },
              on: { "sort-change": _vm.sortTableFun },
            },
            [
              _vm._l(
                _vm.config,
                function (
                  {
                    type,
                    prop,
                    label,
                    width,
                    slot,
                    align,
                    fixed,
                    sortable,
                    fixWidth,
                    children,
                    prophtml,
                  },
                  index
                ) {
                  return [
                    type
                      ? _c("el-table-column", {
                          key: index,
                          attrs: {
                            label: label,
                            type: type,
                            width: width,
                            align: align,
                          },
                        })
                      : slot
                      ? _c("el-table-column", {
                          key: index,
                          attrs: {
                            prop: prop,
                            label: label,
                            "min-width": width,
                            width: fixWidth,
                            fixed: fixed,
                            align: align,
                            sortable: sortable,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    slot === "image"
                                      ? _c("el-image", {
                                          attrs: {
                                            src: _vm.imageArr[scope.$index],
                                            "preview-src-list": _vm.imageArr,
                                          },
                                        })
                                      : _vm._e(),
                                    slot === "index"
                                      ? _c("el-input", {
                                          attrs: { placeholder: "请输入内容" },
                                          model: {
                                            value: scope.$index,
                                            callback: function ($$v) {
                                              _vm.$set(scope, "$index", $$v)
                                            },
                                            expression: "scope.$index",
                                          },
                                        })
                                      : _vm._e(),
                                    slot === "input"
                                      ? _c("el-input", {
                                          attrs: { placeholder: "请输入内容" },
                                          model: {
                                            value: scope.row.goodsNo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "goodsNo",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.goodsNo",
                                          },
                                        })
                                      : _vm._e(),
                                    slot === "money"
                                      ? _c("p", [
                                          _vm._v(_vm._s(scope.row.moneyFormat)),
                                        ])
                                      : _vm._e(),
                                    slot === "button"
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onShowDetail(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        )
                                      : _vm._e(),
                                    slot === "html"
                                      ? _c("p", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              scope.row.goodsNo +
                                                "<br>" +
                                                scope.row.categoryName
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    slot === "state"
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              class: [
                                                "status",
                                                {
                                                  stop: scope.row.status === 2,
                                                },
                                              ],
                                            },
                                            [
                                              scope.row.status === 1
                                                ? _c("span", [_vm._v("开启")])
                                                : _vm._e(),
                                              scope.row.status === 2
                                                ? _c("span", [_vm._v("停用")])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                    slot === "operation"
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "operation-but" },
                                            [
                                              _vm.typeStr == "fans"
                                                ? _c(
                                                    "el-link",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.operation(
                                                            "edit",
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("编辑")]
                                                  )
                                                : _vm._e(),
                                              scope.row.status === 2
                                                ? _c(
                                                    "el-link",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.operation(
                                                            "enable",
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("开启")]
                                                  )
                                                : _vm._e(),
                                              scope.row.status === 1
                                                ? _c(
                                                    "el-link",
                                                    {
                                                      attrs: { type: "danger" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.operation(
                                                            "disable",
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("停用")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : children
                      ? _c(
                          "el-table-column",
                          {
                            key: prop,
                            attrs: {
                              prop: prop,
                              label: label,
                              "min-width": width,
                              width: fixWidth,
                              align: align,
                              sortable: sortable,
                            },
                          },
                          _vm._l(
                            children,
                            function (itemchildren, indexchildren) {
                              return _c("el-table-column", {
                                key: indexchildren,
                                attrs: {
                                  prop: itemchildren.prop,
                                  "min-width": itemchildren.width,
                                  width: itemchildren.fixWidth,
                                  label: itemchildren.label,
                                  "show-overflow-tooltip": "",
                                  align: itemchildren.align,
                                  sortable: itemchildren.sortable,
                                },
                              })
                            }
                          ),
                          1
                        )
                      : _c("el-table-column", {
                          key: prop,
                          attrs: {
                            prop: prop,
                            label: label,
                            "min-width": width,
                            width: fixWidth,
                            align: align,
                            sortable: sortable,
                          },
                        }),
                  ]
                }
              ),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }